import Popup from "./canvas/partials/Popup";

class Events {

    /**
     * Отправляет ajax запрос с данными о текущем канвасе и скачивает сгенерированный PDF файл
     * Send request for generating PDF file
     * @param object - ConfiguratorCanvas instance
     * */
    generatePdf(object) {

        let icon = $('.js-configurator-pdf');

        /*Общие данные конфигуратора*/
        let configData = object.sofa.configData;

        /*Если текущий материал недоступен, показываем попап*/
        if(!object.materialAvailable) {
            object.materialAlert.show();
        }

        let currentSofa = configData.sections[0];
        let itemName = $('.constructor-canvas').data('sofa-name');

        /*Чтоб картинка не выглядела маленькой, если генерили с мобильного*/
        let pixelRatio = object.containerWidth > 0
            ? Math.round(1010 / object.containerWidth).toFixed(2)
            : 1;

        /*Получаем каринку*/
        let dataURL = object.stage.toDataURL({
            mimeType: 'image/jpg',
            quality: 1.0,
            pixelRatio: pixelRatio,
        });

        let total = $('.js-configurator-price').text();
        let activeMaterial = $('.js-material-item.is-current').eq(0);
        let materialName = activeMaterial.data('material-name');
        let materialColor = activeMaterial.data('material-color')

        if(!object.materialAvailable) {
            object.materialAlert.hide();
        }

        let modules = [];

        /*Заполняем модули*/
        object.sofa.state.forEach(function (el) {

            let sameItems = object.sofa.state.filter(item => item.id === el.id);

            console.log('configData.sections', configData.sections);

            console.log('count of', el.id, sameItems.length);

            let module = {
                id: el.id,
                name: currentSofa[el.id]['name'],
                sizes: currentSofa[el.id]['sizes'],
                price: object.sofa.helpers.formattedPrice(currentSofa[el.id]['price']),
                count: sameItems.length
            };

            let exist = modules.filter(item => item.id === el.id);

            if(!exist.length) {
                modules.push(module);
            }

        });

        $.ajax({
            url: ajaxurl,
            dataType: 'json',
            type: 'post',
            data: {
                action: 'get_configurator_pdf',
                clientName: 'tester',
                clientSurname: 'tester',
                title: itemName,
                image: dataURL,
                modules: modules,
                total: total,
                materialName: materialName,
                materialColor: materialColor,
                materialAvailable: true,
            },
            beforeSend: function() {
                icon.addClass('active')
            },
            success: function (response) {

                let a = document.createElement('a');
                a.href = response;
                a.download = response.split('/').pop();
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            },
            complete: function () {
                icon.removeClass('active')
            }
        })
    }

    /**
     * запрос на отправку E-mail
     * Send request for generating PDF file
     * @param object - ConfiguratorCanvas instance
     * */
    sendEmail(object) {

        /*Общие данные конфигуратора*/
        let configData = object.sofa.configData;

        let form = $($('.js-constructor-pre-order').data('mfp-src'));
        let dataInput = form.find('.js-hidden-data');

        /*Если текущий материал недоступен, показываем попап*/
        if(!object.materialAvailable) {
            object.materialAlert.show();
        }

        let currentSofa = configData.sections[0];
        let itemName = $('.constructor-canvas').data('sofa-name');

        /*Чтоб картинка не выглядела маленькой, если генерили с мобильного*/
        let pixelRatio = object.containerWidth > 0
            ? Math.round(1010 / object.containerWidth).toFixed(2)
            : 1;

        /*Получаем картинку*/
        let dataURL = object.stage.toDataURL({
            mimeType: 'image/jpg',
            quality: 1.0,
            pixelRatio: pixelRatio,
        });
        let activeMaterial = $('.js-material-item.is-current').eq(0);
        let materialName = activeMaterial.data('material-name');
        let materialColor = activeMaterial.data('material-color')
        let total = $('.js-configurator-price').text();

        if(!object.materialAvailable) {
            object.materialAlert.hide();
        }

        let modules = [];

        object.sofa.state.forEach(function (el) {

            let sameItems = object.sofa.state.filter(item => item.id === el.id);

            console.log('count of', el.id, sameItems.length);
            console.log('configData.sections', configData.sections);

            let module = {
                id: el.id,
                name: currentSofa[el.id]['name'],
                sizes: currentSofa[el.id]['sizes'],
                price: currentSofa[el.id]['price'],
                count: sameItems.length
            };

            let exist = modules.filter(item => item.id === el.id);

            if(!exist.length) {
                modules.push(module);
            }

        });

        let data =  {
            title: itemName,
            image: dataURL,
            modules: modules,
            materialName: materialName,
            materialColor: materialColor,
            total: total,
            materialAvailable: true,
        };

        dataInput.val(JSON.stringify(data))
    }

    /**
     * Проверка на то, доступен ли рендер материала и, если он доступен - замена картинок
     * @param $item {jQuery} - jQuery объект
     * @param object {ConfiguratorCanvas} - ConfiguratorCanvas объект
     * */
    checkMaterial($item, object) {

        let noPillowAlert = $('.no-pillow-alert--canvas')
        let materialName = $item.data('material-name');
        let materialColor = $item.data('material-color');
        let materialTypeId = $item.data('material-type-id');
        let materialTypeName = $item.data('material-type-name');
        let modules_num = object.sofa.state.map((item) => {
            return item.id;
        });

        let materialParent = $item.parents('.material__list').clone();
        let materialPillowsWrap = $('.js-material-pillows');
        let materialPillowsName = materialPillowsWrap.find('.js-material-cat-name');
        let materialPillowsColorList = materialPillowsWrap.find('.material')
        let materialPillowsColorListItems = materialParent.find('.js-material-item')
        let currentPillowsColorListItem = materialPillowsColorListItems.eq($item.index())

        $.ajax({
            url: ajaxurl,
            dataType: 'json',
            type: 'post',
            data: {
                action: 'change_material',
                postId: object.sofa.currentSofa,
                materialName: materialName,
                materialColor: materialColor,
                materialTypeId: materialTypeId,
                materialTypeName: materialTypeName,
                modules: modules_num
            },
            beforeSend: function() {
                object.$loaderOptions.removeClass('d-none');
            },
            success: function (response) {

                object.sofa.sections.forEach((item, index) => {
                    let responseItem = response.modules[0][index];
                    item.image.front.src = responseItem.image.front.src;
                    item.image.back.src = responseItem.image.back.src;
                    item.image.frontRight.src = responseItem.image.frontRight.src;
                    item.image.frontLeft.src = responseItem.image.frontLeft.src;
                })

                console.log('checkMaterial response', response.modules);

                object.pillows.destroyPillows()
                object.loadImages(object.sofa.sections, object.sofa.helpers.changeMaterial);
                object.sofa.calculatePrice();

                if(response.successful_material_change === false) {
                    object.materialAvailable = false;
                    $('.no-image-alert--canvas').show();
                    noPillowAlert.hide();
                    object.$loaderOptions.addClass('d-none');
                }
                else {
                    object.materialAvailable = true;
                    $('.no-image-alert--canvas').hide();
                }
            },
            complete: function () {
                if(materialName !== materialPillowsWrap.find('.js-material-cat-name').text()) {

                    materialPillowsColorListItems.removeClass('js-material-item is-current').addClass('js-material-pillow-item')
                    currentPillowsColorListItem.addClass('is-current')
                    materialPillowsColorList.children().remove()
                    materialPillowsColorList.append(materialParent)
                    materialPillowsName.text(materialName)

                    object.pillows.showPillows(currentPillowsColorListItem);

                }
            }
        })
    };

    checkAllMaterials(object) {

        $.ajax({
            url: ajaxurl,
            dataType: 'json',
            type: 'post',
            data: {
                action: 'check_all_materials',
                postId: object.sofa.currentSofa
            },
            beforeSend: function() {
                object.$loaderOptions.removeClass('d-none');
            },
            success: function (response) {
                console.log('response check all materials', response)
            },
            complete: function () {
                object.$loaderOptions.addClass('d-none');
            }
        })
    }
}

export default Events;
